export default {
      id: "icon-close-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }